import * as angular from 'angular';
import {IController} from 'angular';

export class CustomOrderPlanningErrorsTableComponent implements IController {
  rowsVerifications: any[];

  constructor() {
  }

  $onInit() {
  }

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.getElementById('custom-order-planning-errors-container');

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


}

angular
  .module('bringoz.admin.order-planning-configuration')
  .component('customOrderPlanningErrorsTable', {
    bindings: {
      rowsVerifications: '<?'
    },
    template: require('./custom-order-planning-errors-table.html').default,
    controller: CustomOrderPlanningErrorsTableComponent
  });
